import React from "react";
import { useAuth } from "../context/AuthContext";
import { COUNTERS, downloadCounterSetup } from "../lib/counterSetup";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { AlertTriangle, ChevronDown, Download } from "lucide-react";

// True in the window opened by a counter's direct-print desktop shortcut (Chrome --kiosk-printing).
export const directPrintOn = () => { try { return localStorage.getItem("pd_direct_print") === "1"; } catch { return false; } };
const onWindowsPc = /Windows/.test(navigator.userAgent);

// Admins only: warns that this window shows the print dialog and offers the one-time counter PC setup.
// only: counter keys to offer on this page (e.g. ["idcard"]); one key = the button downloads that setup directly.
export default function DirectPrintBanner({ templeId, className = "mb-4", only }) {
  const { user } = useAuth();
  if (!onWindowsPc || directPrintOn() || !["SUPER_ADMIN", "TEMPLE_ADMIN"].includes(user?.role)) return null;
  const tid = templeId || user.temple_id || "";
  const list = only ? COUNTERS.filter((c) => only.includes(c.key)) : COUNTERS;
  return (
    <div className={`${className} rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 hidden md:flex flex-col sm:flex-row sm:items-center gap-2`} data-testid="direct-print-banner">
      <AlertTriangle className="w-5 h-5 shrink-0 text-amber-600" />
      <p className="flex-1">
        <b>Print dialog will appear in this window.</b> For direct printing open the counter's <b>"(Direct Print)"</b> shortcut from the desktop.
        Not set up on the counter PC yet? Download the setup for that counter, run it once and choose the ticket printer.
      </p>
      {list.length === 1 ? (
        <button type="button" onClick={() => downloadCounterSetup(tid, list[0].key)} data-testid="direct-print-setup-btn"
          className="shrink-0 h-9 px-3 rounded-lg bg-maroon-700 text-white font-semibold inline-flex items-center justify-center gap-1.5">
          <Download className="w-4 h-4" /> Download {list[0].name} setup
        </button>
      ) : (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button type="button" data-testid="direct-print-setup-btn"
            className="shrink-0 h-9 px-3 rounded-lg bg-maroon-700 text-white font-semibold inline-flex items-center justify-center gap-1.5">
            <Download className="w-4 h-4" /> Download setup <ChevronDown className="w-4 h-4" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-64">
          <DropdownMenuLabel className="text-xs text-slate-500">Which counter is this PC?</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {list.map((c, i) => (
            <DropdownMenuItem key={c.key} onSelect={() => downloadCounterSetup(tid, c.key)} data-testid={`direct-print-setup-${c.key}`} className="cursor-pointer">
              {i + 1}. {c.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      )}
    </div>
  );
}
